/*
  Size guide pop-up (snippets/joyvo-pdp-size-guide.liquid): a native <dialog>. The link opens it, the X, a click on the dark area
  and the Escape key close it. One listener on the page, so it keeps working when the theme redraws parts of the product info.
*/
document.addEventListener('click', (event) => {
  const open = event.target.closest('[data-jv-sg-open]');
  if (open) {
    const dialog = open.closest('.jv-sg').querySelector('[data-jv-sg-dialog]');
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }
  const dialog = event.target.closest('[data-jv-sg-dialog]');
  if (!dialog) return;
  // the X, or a click on the dark backdrop (the dialog element itself, outside the card)
  if (event.target.closest('[data-jv-sg-close]') || event.target === dialog) dialog.close();
});

/* "Size: 6-12 months": Dawn writes the raw supplier value into the heading when a size is picked; put the shown label back
   (each Size button carries it in data-display). */
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.matches || !input.matches('variant-selects input[type="radio"][data-display]')) return;
  const target = input.closest('.product-form__input')?.querySelector('[data-selected-value]');
  if (target) setTimeout(() => { target.textContent = input.dataset.display; }, 0);
}, true);
